document.addEventListener('DOMContentLoaded', () => {
	const mq = window.matchMedia('(min-width: 992px)')
	const sections = document.querySelectorAll('.img-grid-accordion')

	if (!sections.length) return

	const setActiveCard = (section, activeIndex) => {
		const cards = section.querySelectorAll('.img-grid-accordion__card')

		cards.forEach((card, index) => {
			card.classList.toggle('is-active', index === activeIndex)
		})
	}

	const updateSection = section => {
		const track = section.querySelector('.img-grid-accordion__track')
		const cards = section.querySelectorAll('.img-grid-accordion__card')

		if (!track || !cards.length) return

		const rect = track.getBoundingClientRect()
		const viewportHeight = window.innerHeight
		const scrollable = rect.height - viewportHeight

		if (scrollable <= 0) {
			setActiveCard(section, 0)
			return
		}

		let progress = -rect.top / scrollable
		progress = Math.max(0, Math.min(1, progress))

		const steps = cards.length
		const activeIndex = Math.min(steps - 1, Math.floor(progress * steps))

		setActiveCard(section, activeIndex)
	}

	const updateAllSections = () => {
		if (!mq.matches) {
			sections.forEach(section => {
				const cards = section.querySelectorAll('.img-grid-accordion__card')
				cards.forEach(card => card.classList.remove('is-active'))
			})
			return
		}

		sections.forEach(updateSection)
	}

	const setDynamicTrackHeight = () => {
		if (!mq.matches) return

		sections.forEach(section => {
			const cards = section.querySelectorAll('.img-grid-accordion__card')
			const track = section.querySelector('.img-grid-accordion__track')

			if (!track || !cards.length) return

			const vhPerCard = 90
			track.style.height = `${cards.length * vhPerCard}vh`
		})
	}

	setDynamicTrackHeight()
	updateAllSections()

	window.addEventListener('scroll', updateAllSections, { passive: true })
	window.addEventListener('resize', () => {
		setDynamicTrackHeight()
		updateAllSections()
	})

	mq.addEventListener('change', () => {
		setDynamicTrackHeight()
		updateAllSections()
	})
})
